import React from "react";
import WhiteCover from "../WhiteCover/WhiteCover";
import LondonCleanerzLogo from "../../assets/images/london_cleaners.png";
import "./ProfessionalCleaning.scss";

export default function ProfessionalCleaning() {
  return (
    <WhiteCover className="professional-cleaning">
      <div className="cleaning-container">
        <div className="logo-section">
          <img src={LondonCleanerzLogo} alt="London Cleanerz Logo" />
        </div>
        <div className="content-section">
          <h2 className="h1-sb cleaning-heading">
            Professional grade cleaning solutions
          </h2>
          <p className="h3-alt cleaning-description">
            Our subsidiary, London Cleanerz, provide the specialised staffing
            and hospitality expertise your venue demands to thrive.
          </p>
          <a
            href="https://londoncleanerz.com"
            target="_blank"
            rel="noopener noreferrer"
            className="primary-btn-black"
          >
            Visit London Cleanerz
          </a>
        </div>
      </div>
    </WhiteCover>
  );
}
